import { STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type IPrivateDocument, privateFoldersManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { MOVE_TO_FOLDER } from '../base/binary-uploads/actions';

export const actions: ActionTree<IPrivateDocument, unknown> = {
    async [MOVE_TO_FOLDER](context, { dobjId, destinationId, properties }: { dobjId: number; destinationId: number; properties?: string }): Promise<number> {
        const result = await privateFoldersManager.moveFolderToFolder(dobjId, destinationId, { properties });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
        return result.dobjId;
    }
};
